import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const NoWorkers = () => (
  <div className="flex flex-col items-center text-center px-6 py-14">
    <span className="grid place-items-center w-12 h-12 rounded-full bg-brand-50 text-brand-500 mb-4">
      <FontAwesomeIcon icon="helmet-safety" className="text-[18px]" />
    </span>
    <h3 className="text-[15px] font-semibold text-slate-900">{I18n.t("project_planning.empty.title")}</h3>
    <p className="mt-1.5 max-w-md text-[13px] leading-relaxed text-slate-500">{I18n.t("project_planning.empty.body")}</p>
    <p className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-slate-50 border border-slate-200 text-[12px] text-slate-600">
      <FontAwesomeIcon icon="square-check" className="text-brand-500" />
      {I18n.t("project_planning.empty.permission")}
    </p>
  </div>
)

export default NoWorkers
